import type { BrandsSelected } from "@/Models/MBrand/BrandsSelected";
import type { products } from "@/Models/MProduct/Products";
import type { MSubCategoryHijaSubcategoryV2 } from "@/Models/MSubCategories/MPLPCategory";

export const ListBrand = (
  //data: products[]
  data: MSubCategoryHijaSubcategoryV2[],
  category: string,
  subCategory: string
) => {
  if (data && data.length > 0) {
    const mapBrandToData = (x: products): BrandsSelected => ({
      brand: x.Brand,
    });

    const datosFilter_v2 =
      data
        ?.find((w) => w.Id === category)
        ?.SubCategories?.filter(
          (s) =>
            s.Id.includes(subCategory.toLowerCase()) &&
            Array.isArray(s.Products) &&
            s.Products.length > 0
        )
        ?.flatMap((f) => f.Products) ?? [];

    const mappedDataBrand = datosFilter_v2.map(mapBrandToData);

    return mappedDataBrand;
  }
  return [];
};
